<div class="gyartas">

  <div class="gyartas__head">
    <div class="gyartas__head-main">
      <h1 class="stk-page-title">Gyártás</h1>
      <div class="stk-page-sub">Nyomtatási feladatok a minimum szint és az aktív rendelések alapján — fontossági sorrendben.</div>
    </div>
    <!-- A lista rögzítés után szándékosan NEM rendeződik át (nehogy a gombok
         elcsússzanak a kurzor alól) — az újrarendezés kézzel, itt indul. -->
    <button type="button" class="gyartas__refresh" (click)="refresh()" [disabled]="loading"
            title="Lista újrarendezése és a kész tételek eltávolítása">
      Lista frissítése<span *ngIf="hasCompletedRows"> ·  kész tételek</span>
    </button>
  </div>

  <div class="mfg-stats" *ngIf="!loading && !loadFailed">
    <div class="mfg-stat">
      <div class="mfg-stat__label">Nyomtatandó</div>
      <div class="mfg-stat__value">{{ totalPieces }} db</div>
      <div class="mfg-stat__sub">{{ taskCount }} feladat</div>
    </div>
    <div class="mfg-stat">
      <div class="mfg-stat__label">Becsült nyomtatási idő</div>
      <div class="mfg-stat__value">{{ hoursLabel }}</div>
      <div class="mfg-stat__sub">a teljes sorra</div>
    </div>
    <div class="mfg-stat">
      <div class="mfg-stat__label">Anyagigény</div>
      <div class="mfg-stat__value">{{ gramsLabel }}</div>
      <div class="mfg-stat__sub">filament összesen</div>
    </div>
  </div>

  <!-- Egyedi gyártás: rendelésre készülő tételek. Nem készlet-utántöltés,
       ezért külön blokkban, rendelésszámmal és personalizációs szöveggel. -->
  <div class="mfg-custom" *ngIf="!loading && !loadFailed && customRows.length">
    <div class="mfg-custom__head">
      <span class="mfg-badge mfg-badge--custom">Egyedi gyártás</span>
      <span class="mfg-custom__head-sub">
        {{ customOpenCount }} tétel · {{ customPieces }} db · {{ customHoursLabel }}
      </span>
    </div>

    <div class="mfg-custom-task" *ngFor="let row of customRows"
         [class.mfg-custom-task--done]="row.done">
      <div class="mfg-custom-task__top">
        <img *ngIf="row.job.imageFile" class="mfg-task__img"
             [appFetchComponentImage]="row.job.imageFile" [alt]="row.job.name">
        <div *ngIf="!row.job.imageFile" class="mfg-task__img mfg-task__img--placeholder">kép</div>

        <div class="mfg-custom-task__main">
          <div class="mfg-task__name-row">
            <span class="mfg-badge mfg-badge--custom">Egyedi gyártás</span>
            <button type="button" class="mfg-custom-task__order" (click)="openOrder(row)"
                    title="Rendelés megnyitása">{{ row.orderLabel }}</button>
          </div>
          <div class="mfg-custom-task__name">{{ row.job.name }}</div>
          <div class="mfg-task__meta">{{ row.meta }}</div>
        </div>

        <div class="mfg-task__col mfg-task__col--need">
          <div class="mfg-task__col-label">Gyártandó</div>
          <div class="mfg-task__need">{{ row.job.quantity }} db</div>
          <div class="mfg-task__need-time">{{ row.needTime }}</div>
        </div>

        <div class="mfg-custom-task__side">
          <div class="mfg-custom-task__deadline" *ngIf="row.deadlineLabel"
               [class.mfg-custom-task__deadline--late]="row.deadlineLate">
            Határidő: {{ row.deadlineLabel }}
          </div>
          <button type="button" class="mfg-custom-task__btn"
                  [class.mfg-custom-task__btn--done]="row.done"
                  [disabled]="customPending[row.job.orderProductId]"
                  (click)="toggleCustomDone(row)"
                  [title]="row.done ? 'Visszaállítás gyártandóra' : 'Legyártva jelölés'">
            {{ row.done ? 'Legyártva' : 'Kész' }}
          </button>
        </div>
      </div>

      <!-- A webshopban megadott personalizációs szöveg — ez alapján készül a darab. -->
      <div class="mfg-perso" *ngIf="row.job.personalization">
        <div class="mfg-perso__label">
          Personalizáció
          <button type="button" class="mfg-perso__copy" (click)="copyPersonalization(row)"
                  title="Szöveg másolása">másolás</button>
        </div>
        <div class="mfg-perso__text">{{ row.job.personalization }}</div>
      </div>
      <div class="mfg-perso mfg-perso--empty" *ngIf="!row.job.personalization">
        Nincs megadott personalizációs szöveg — egyeztesd a vevővel a rendelés alatt.
      </div>
    </div>
  </div>

  <div class="mfg-list" *ngIf="!loading">

    <div class="mfg-task" *ngFor="let row of rows; trackBy: trackBySku" #taskEl [attr.data-sku]="row.task.sku"
         [ngClass]="'mfg-task--' + row.tone" [class.mfg-task--done]="row.done">
      <div class="mfg-task__top">
        <img *ngIf="row.task.imageFile && visibleSkus.has(row.task.sku)" class="mfg-task__img" [appFetchComponentImage]="row.task.imageFile" [alt]="row.task.name">
        <div *ngIf="!row.task.imageFile || !visibleSkus.has(row.task.sku)" class="mfg-task__img mfg-task__img--placeholder">kép</div>
        <div class="mfg-task__main">
          <div class="mfg-task__name-row">
            <span class="mfg-task__name">{{ row.task.name }}</span>
            <span class="stk-pill mfg-badge" [ngClass]="row.badgeClass" *ngIf="!row.done">{{ row.badgeLabel }}</span>
            <span class="mfg-badge mfg-badge--ok" *ngIf="row.done">Megvan a cél</span>
            <span class="mfg-badge mfg-badge--custom" *ngIf="row.task.isCustom">Egyedi</span>
            <span class="mfg-badge mfg-badge--logged" *ngIf="row.justLogged > 0">+{{ row.justLogged }} db rögzítve</span>
          </div>
          <div class="mfg-task__meta">{{ row.meta }}</div>
        </div>
        <div class="mfg-task__col">
          <div class="mfg-task__col-label">Készleten</div>
          <div class="mfg-task__stock" [class.mfg-task__stock--out]="(row.task.stock || 0) <= 0">{{ row.task.stock || 0 }} db</div>
        </div>
        <div class="mfg-task__col mfg-task__col--need">
          <div class="mfg-task__col-label">Nyomtatandó</div>
          <div class="mfg-task__need">{{ row.task.need }} db</div>
          <div class="mfg-task__need-time">{{ row.needTime }}</div>
        </div>
        <div class="mfg-task__log">
          <input #qty class="mfg-task__input" [value]="inputs[row.task.sku] || ''"
                 (input)="onQtyInput(row.task.sku, qty)" (keydown.enter)="log(row)"
                 placeholder="elkészült db" size="4">
          <button type="button" class="mfg-task__btn" [class.mfg-task__btn--on]="canLog(row.task.sku)"
                  [disabled]="!canLog(row.task.sku)" (click)="log(row)"
                  title="Elkészült darabok hozzáadása a készlethez">Rögzítés</button>
        </div>
      </div>
      <div class="mfg-task__progress">
        <div class="mfg-task__bar">
          <div class="mfg-task__fill" [class.mfg-task__fill--red]="row.progRed" [style.width.%]="row.pct"></div>
        </div>
        <span class="mfg-task__prog-label">{{ row.progLabel }}</span>
      </div>
    </div>

    <!-- Üres állapot: minden komponens minimum felett -->
    <div class="mfg-empty" *ngIf="!loadFailed && rows.length === 0">
      <div class="mfg-empty__icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#4C7A2E" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="4,12.5 9.5,18 20,6"></polyline></svg>
      </div>
      <div class="mfg-empty__title">Minden komponens minimum szint felett van</div>
      <div class="mfg-empty__sub" *ngIf="!customRows.length">Nincs nyomtatási feladat. Új rendelés vagy készletmozgás után frissül a sor.</div>
      <div class="mfg-empty__sub" *ngIf="customRows.length">Készlet-utántöltésre nincs feladat — csak a fenti egyedi gyártás van soron.</div>
    </div>

    <!-- Hiba állapot: a production API még nem érhető el -->
    <div class="mfg-empty" *ngIf="loadFailed">
      <div class="mfg-empty__icon mfg-empty__icon--muted">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#707870" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="9"></circle><line x1="12" y1="11" x2="12" y2="16"></line><circle cx="12" cy="8" r="0.4" fill="#707870"></circle></svg>
      </div>
      <div class="mfg-empty__title">A gyártási sor nem érhető el</div>
      <div class="mfg-empty__sub">A gyártási várólista még nem válaszol — próbáld meg később újra.</div>
    </div>

  </div>

</div>
